// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.screenfull-svg[data-v-29234bee] {\n    display: inline-block;\n    cursor: pointer;\n    fill: #5a5e66;\n    width: 20px;\n    height: 20px;\n    vertical-align: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
